import React, { Component } from "react";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

class Privacy extends Component {
  render() {
    const { auth } = this.props;

    const style = {
      imageHero: {
        backgroundImage: `url("/images/tikki-background.jpg")`,
        // backgroundImage: `url(${randomProperty(projects).imageHero})`,
        backgroundPosition: "center center no-repeat",
        backgroundSize: "cover",
        minHeight: 450,
        maxHeight: 450
      }
    };

    const styleSummary = {
      backgroundColor: "#A2D9D6",
      padding: "25px",
      borderRadius: "5px",
      MozBorderRadius: "5px",
      WebkitBorderRadius: "5px"
    };

    return (
      <div>
        <Header auth={auth} />
        <div style={style.imageHero} />
        <div className="about-main tikki-shadow">
          <h3>Privacy policy</h3>

          <h4>In a nutshell</h4>

          <p style={styleSummary}>
            Where it is within our power, we will do everything to protect the
            privacy of each of our amazing world changers (users) in the Tikki
            community. We hold data that users disclose to us, but we don't pass
            on data of individuals.
          </p>

          <h4>The more wordy and detailed explanation</h4>

          <p>
            tikki.org, an online service managed by Tikki Global, headquartered
            in Melbourne, Australia. We respect and protect the privacy of our
            users. This privacy policy tells you how we collect and use
            information.
          </p>
          <p>
            The term "Personal Information" in this privacy policy means any
            information from which your identity is apparent or can be
            reasonably ascertained.
          </p>

          <h4>Scope</h4>

          <p>
            The purpose of this online service is to provide you with
            information about Projects of registered non-profits and raise
            donations for non-profits. On the platform you can also manage your
            history and engagement with non-profits projects.
          </p>

          <h4>Personal information</h4>

          <p>
            If you contact us or set up a user account on Tikki, we will collect
            the email address you nominate and any other identifying information
            you provide such as name or phone number. If you make a donation on
            our site, we use external payment gateway services and disclose
            necessary information to the non-profits you donated to in order to
            obtain tax deductable receipts for you.
          </p>
          <p>
            Other than circumstances such as unlawful activity or serious
            threats to health and safety, we do not share Personal Information.
            If you ask us about an issue that needs to be dealt with by another
            entity, we will provide you with the necessary details to make
            contact yourself. You may opt out of further contact from us at any
            time.
          </p>

          <h4>How we deal with complaints and requests</h4>

          <p>
            In your Profile Page you can view Personal Information that we hold
            about you and you can update Personal Information if you find that
            it is not accurate, up-to-date or complete. You can remove your
            Profile at any time.
          </p>
          <p>
            To protect your privacy and the privacy of others, we will need
            evidence of your identity before we can grant you access to
            information about you or change it.
          </p>
          <p>
            You can contact us we undertake to respond within 30 days. If the
            request or complaint will take longer to resolve, we will provide
            you with a date by which we expect to respond.
          </p>
          <h4>How we protect your Personal Information</h4>
          <p>
            We host tikki via a cloud service provider. To help protect the
            privacy of data and personal information we collect and hold, we
            update and test our security infrastructure on an ongoing basis.{" "}
          </p>
          <p>
            We train our team about the importance of confidentiality and
            maintaining the privacy and security of your information. Access to
            your Personal Information is restricted to Tikki team members who
            need it to provide benefits or services to you.
          </p>

          <h4> Website analytics</h4>

          <p>
            To improve your experience on our site, we may use 'cookies'.
            Cookies are an industry standard and most major web sites use them.
            A cookie is a small text file that our site may place on your
            computer as a tool to remember your preferences. You may refuse the
            use of cookies by selecting the appropriate settings on your
            browser, however please note that if you do this you may not be able
            to use the full functionality of this website.
          </p>
          <p>
            Our website may contain links to other websites. Please be aware
            that we are not responsible for the privacy practices of such other
            sites. When you go to other websites from here, we advise you to be
            aware and read their privacy policy.
          </p>
          <p>
            Our website uses Google Analytics, a service which transmits website
            traffic data to Google servers in the United States. Google
            Analytics does not identify individual users or associate your IP
            address with any other data held by Google. We use reports provided
            by Google Analytics to help us understand website traffic and
            webpage usage.
          </p>
          <p>
            By using this website, you consent to the processing of data about
            you by Google in the manner described in Google’s Privacy and for
            the purposes set out above. You can opt out of Google Analytics if
            you disable or refuse the cookie, disable JavaScript, or use the
            opt-out service provided by Google,
            https://tools.google.com/dlpage/gaoptout.
          </p>
          <p>
            tikki.org also uses interfaces with social media sites such as
            Facebook, LinkedIn, Twitter and others. If you choose to "like" or
            "share" information from this website through these services, you
            should review the privacy policy of that service. If you are a
            member of a social media site, the interfaces may allow the social
            media site to connect your visits to this site with other personal
            information.
          </p>

          <h4>Our obligations</h4>

          <p>
            This online service is bound by the provisions of the Privacy Act
            1988.
          </p>

          <h4>Contact us</h4>

          <p>Contact us about your privacy concerns at hello@tikki.org.</p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Privacy;



// WEBPACK FOOTER //
// ./src/pages/PrivacyPage.js